import { AppBar, Box, Divider, Toolbar } from '@mui/material';
import { ReactNode, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { styled } from 'styled-components';
import Logo from './../../assets/STATO-INTOO-LOGO-MY-INTOO-VERS-2 A.png';
import MenuHorizontal from './Menu';
import MenuMobile from './MenuMobile';
import { useTranslation } from '../../commons/useTranslasion';

interface LayoutProps {
  children: ReactNode;
}

export interface IMenuItens {
  nome: string; 
  link: string;
  filhos?: IMenuItens[];
}

const Header: React.FC<LayoutProps> = ({ children }) => {
  const { translate } = useTranslation();
  const [menuItens, setMenuItens] = useState<IMenuItens[]>([
    {
      nome: translate("dashboard"),
      link: '/',
      filhos: [],
    },
    {
      nome: translate("programas"),
      link: '/assessorados',
      filhos: [],
    }
  ]);
  const history = useHistory();

  return (
    <>
      <AppBar
        position="fixed"
        color="default"
        elevation={1}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <Toolbar
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            backgroundColor: 'white',
            height: '100px',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={Logo}
              alt="logo"
              width={'220px'}
              onClick={() => history.push('/')}
              style={{ cursor: 'pointer' }}
            />
          </Box>

          <DivMenuDesktop>
            <MenuHorizontal menuItens={menuItens} />
          </DivMenuDesktop>
          <DivMenuMobile>
            <MenuMobile menuItens={menuItens} />
          </DivMenuMobile>
        </Toolbar>
        <DividerMenu />
      </AppBar>

      <Box sx={{ marginTop: '104px', minHeight: 'calc(80vh)' }}>{children}</Box>
    </>
  );
};

export const DividerMenu = styled(Divider)`
  height: 4px;
  width: 100%;
  max-width: 100vw;
  position: relative;
  background: linear-gradient(90deg, var(--blue-light) 0%, var(--green-light) 100%);
`;

const DivMenuDesktop = styled.div`
  @media (max-width: 576px) {
    display: none;
  }
`;

const DivMenuMobile = styled.div`
  @media (min-width: 577px) {
    display: none;
  }
`;

export default Header;
